import { configs } from '@constants/configs/configs';
import { PAGE_SIZE } from '@constants/common.constants';
import { MEMBER_HISTORICAL_NOTICES_ACTION_TYPES } from '@constants/actionTypes/memberHistoricalNoticesActionTypes';
import { createPaginatedFetchThunk } from '@common-actions/createPaginatedFetchThunk';
import {
    HISTORICAL_NOTICES_DEFAULT_SORT_COLUMN,
    HISTORICAL_NOTICES_DEFAULT_SORT_ORDER,
    HISTORICAL_NOTICES_INITIAL_PAGE_NUMBER,
    HISTORICAL_NOTICES_LIST_KEY,
    type IHistoricalNoticesFetchRequest,
    type IHistoricalNoticesListState,
    type IHistoricalNoticesPageData,
} from '@modules/historical-notices/constants';

const buildBasePayload = (request: IHistoricalNoticesFetchRequest) => ({
    hasLoaded: true,
    notices: [],
    totalCount: 0,
    pageNumber: request.pageNumber,
    pageSize: request.pageSize,
    totalPages: 0,
    sortColumn: request.sortColumn,
    sortOrder: request.sortOrder,
});

export const setMemberHistoricalNotices = (payload: IHistoricalNoticesListState) => ({
    type: MEMBER_HISTORICAL_NOTICES_ACTION_TYPES.SET_MEMBER_HISTORICAL_NOTICES,
    payload,
});

export const resetMemberHistoricalNotices = () => ({
    type: MEMBER_HISTORICAL_NOTICES_ACTION_TYPES.RESET_MEMBER_HISTORICAL_NOTICES,
});

export const fetchMemberHistoricalNotices = createPaginatedFetchThunk<
    IHistoricalNoticesFetchRequest,
    IHistoricalNoticesPageData,
    typeof HISTORICAL_NOTICES_LIST_KEY,
    IHistoricalNoticesListState
>({
    getEndpointUrl: () => configs.endpoints.MEMBER_HISTORICAL_NOTICES,
    listKey: HISTORICAL_NOTICES_LIST_KEY,
    setList: setMemberHistoricalNotices,
    requestDefaults: {
        pageNumber: HISTORICAL_NOTICES_INITIAL_PAGE_NUMBER,
        pageSize: PAGE_SIZE,
        sortColumn: HISTORICAL_NOTICES_DEFAULT_SORT_COLUMN,
        sortOrder: HISTORICAL_NOTICES_DEFAULT_SORT_ORDER,
    },
    buildEmptyPayload: (request) => ({ ...buildBasePayload(request), hasLoadError: false }),
    buildErrorPayload: (request) => ({ ...buildBasePayload(request), hasLoadError: true }),
    buildSuccessPayload: (pageData, request) => ({
        ...buildBasePayload(request),
        notices: pageData.userHistoricalNotices,
        totalCount: pageData.totalElements,
        pageNumber: pageData.pageNumber,
        pageSize: pageData.pageSize,
        totalPages: pageData.totalPages,
        hasLoadError: false,
    }),
});
